module.exports = __webpack_public_path__ + "media/images/icons/country_flags/td-ce35efd0cf28cc8886eb7ee531aef6d7.svg";